import React from 'react';
import styles from './LottoBall.module.css';
import { getLottoNumberColor } from '../../utils/lotto';

interface Props {
  number: number;
  size?: 'small' | 'medium';
}

const LottoBall: React.FC<Props> = ({ number, size = 'medium' }) => {
  const colorClass = styles[getLottoNumberColor(number)];
  const sizeClass = styles[size];

  return (
    <div className={`${styles.lottoBall} ${colorClass} ${sizeClass}`}>
      {number}
    </div>
  );
};

export default LottoBall;
